import { Expose, Transform, Type } from 'class-transformer';
import { BaseModel, FormattedDateString, StartOfDate, EndOfDate } from '@red/data-access';
import { EDebtRecoveryOption, EPreLodEmailType, EReminderStage, EWriteOffReason, ReminderSkipTime } from '../enums/payment-reminder.enum';

export class PaymentReminderSkipDto extends BaseModel {
  @Expose()
  stage!: EReminderStage;

  @Expose()
  skipTime!: ReminderSkipTime;

  @Expose()
  @Type(() => Date)
  @FormattedDateString()
  newDueDate!: string;

  @Expose()
  reason?: string;
}

export class PaymentReminderIssueDto extends BaseModel {
  @Expose()
  @Type(() => Date)
  @FormattedDateString()
  issueDate!: string;

  @Expose()
  stage!: EReminderStage;

}

export class PaymentReminderSendPreLodEmailDto extends BaseModel {
  @Expose()
  emailType!: EPreLodEmailType;

  @Expose()
  paymentDeadline!: number;
}

export class PaymentReminderRevertDto extends BaseModel {
  @Expose()
  stage!: EReminderStage;

  @Expose()
  reason!: string;
}

export class DebtRecoveryOptionDto extends BaseModel {
  @Expose()
  debtRecoveryOption!: EDebtRecoveryOption;

  @Expose()
  @Type(() => Date)
  @StartOfDate()
  @FormattedDateString()
  arbitrationIssueDate?: string;

  @Expose()
  @Type(() => Date)
  @StartOfDate()
  @FormattedDateString()
  mediationIssueDate?: string;

  @Expose()
  @Type(() => Date)
  @StartOfDate()
  @FormattedDateString()
  effectiveDate?: string;

  @Expose()
  @Type(() => Date)
  @StartOfDate()
  @FormattedDateString()
  agreementDate?: string;
}

export class WriteOffDto extends BaseModel {
  @Expose()
  writeOffReason!: EWriteOffReason;

  @Expose()
  additionalDetails?: string;
}

export class PaymentReminderBatchDownloadLetterDto extends BaseModel {
  @Expose()
  letterType?: string;

  @Expose()
  @Type(() => Date)
  @StartOfDate()
  @FormattedDateString()
  letterDateStart?: string;

  @Expose()
  @Type(() => Date)
  @EndOfDate()
  @FormattedDateString()
  letterDateEnd?: string;
}

export class PaymentReminderFiltersDto extends PaymentReminderBatchDownloadLetterDto {
  @Expose()
  key!: string;

  @Expose()
  orderBy!: string;

  @Expose()
  orderType!: string;

  @Expose()
  limit!: number;

  @Expose()
  page!: number;

  @Expose()
  searchType!: string;

  @Expose()
  resaleCode!: string;

  @Expose()
  invoiceCode!: string;

  @Expose()
  @Type(() => Date)
  @StartOfDate()
  @FormattedDateString()
  invoiceDateStart!: string;

  @Expose()
  @Type(() => Date)
  @EndOfDate()
  @FormattedDateString()
  invoiceDateEnd!: string;

  @Expose()
  clientName!: string;

  @Expose()
  agentName!: string;

  @Expose()
  resaleStatus!: string;

  @Expose()
  resaleType!: string;

  @Expose()
  debtRecoveryOption!: string;

  @Expose()
  stage!: string;

  @Expose()
  @Type(() => Date)
  @StartOfDate()
  @FormattedDateString()
  dueDateStart!: string;

  @Expose()
  @Type(() => Date)
  @EndOfDate()
  @FormattedDateString()
  dueDateEnd!: string;

  @Expose()
  isSkipped!: boolean;

  @Expose()
  status!: string;

  @Expose()
  @Type(() => Date)
  @StartOfDate()
  @FormattedDateString()
  actualWriteOffDateStart!: string;

  @Expose()
  @Type(() => Date)
  @EndOfDate()
  @FormattedDateString()
  actualWriteOffDateEnd!: string;

}
